import styled from 'styled-components';

const Label = styled.label`
  display: inline-block;
  width: 100%;
  margin-bottom: 5px;
  font-weight: bolder;
`;

export default Label;
